// src/services/aiProfilesService.js

import { api } from "./api";

// Trae todos los perfiles
export const getAIProfiles = async () => {
  try {
    const response = await api.get("/api/ai-profiles/");
    return response.data;
  } catch (error) {
    console.error("Error fetching AI profiles:", error.response || error.message || error);
    return [];
  }
};

// Trae un perfil específico por ID
export const getAIProfileById = async (id) => {
  try {
    const response = await api.get(`/api/ai-profiles/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching AI profile with ID ${id}:`, error.response || error.message || error);
    return null;
  }
};

// export const getAIProfiles = async () => {
//   try {
//     const response = await api.get("/api/ai-profiles/");
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching AI profiles:", {
//       message: error.message,
//       response: error.response,
//       code: error.code,
//       config: error.config,
//     });
//     return [];
//   }
// };